import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { AdyenComponentRef } from '@/services/Adyen.service';
import { valueof } from '@/types';
import { PAYMENT_PLATFORMS } from '@/constants/checkout';

export const loadPaymentProvider = createAppAsyncThunk(
  'checkout/loadPaymentProvider',
  async (payload: Payload, { getState, rejectWithValue, extra: { checkoutService } }) => {
    const storeId = getState().root.storeConf.storeId;
    const paymentMode = !payload.isQuickPay ? getState().cart.content.paiementMode : undefined;
    const cartId = getState().cart.content.id;
    try {
      return await checkoutService.loadPaymentProvider(
        payload.paymentProvider, { storeId, paymentMode, binding: payload.binding, cartId, getState, translate: payload.t }
      );
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const initPaymentProvider = createAppAsyncThunk(
  'checkout/initPaymentProvider',
  async (configuration: Record<string, unknown> | undefined, { rejectWithValue, getState, extra: { checkoutService } }) => {
    const locale = getState().root.storeConf.locale;
    const username = getState().cart.content.paiementMode.hipayLogin;
    const password = getState().cart.content.paiementMode.hipayPassword;

    try {
      return await checkoutService.initPaymentProvider({ locale, username, password }, configuration);
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const createPaymentProviderForm = createAppAsyncThunk(
  'checkout/createPaymentProviderForm',
  async (_, { getState, dispatch, rejectWithValue, extra: { checkoutService } }) => {
    const paymentMode = getState().cart.content.paiementMode;
    const chosenPaymentProvider = getState().checkout.paymentProvider.label as PaymentProvider;

    try {
      return await checkoutService.createPaymentProviderForm(paymentMode, chosenPaymentProvider, dispatch);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type Payload = {
  paymentProvider: valueof<typeof PAYMENT_PLATFORMS>;
  binding?: AdyenComponentRef,
  isQuickPay?: boolean;
  t?: (key: string) => string
}
export type PaymentProvider = keyof typeof PAYMENT_PLATFORMS;
